<template>
    <div class="home">
        <iframe
            class="expert"
            :src="src"
        >
        </iframe>
    </div>
</template>

<script>
export default {
    name: 'wz-expert',
    data() {
        return {
            src: 'https://expert.baidu.com/#/pages/wz/triage/index?vn=med&atn=triage&title=%E5%8C%BB%E7%94%9F%E5%8A%A9%E6%89%8B'
        };
    },
    created() {
        let arr = [];
        let query = this.$route.query;
        for (let key in query) {
            arr.push(`${key}=${query[key]}`);
        }
        this.src += '&' + arr.join('&');
        setTimeout(function () {
            const ifm = document.getElementsByClassName('expert')[0];
            const doc = ifm.contentDocument;
            let newScript = doc.createElement('script');
            newScript.src = 'https://cdn.jsdelivr.net/npm/@vant/touch-emulator';
            doc.head.appendChild(newScript);
        }, 3000);
    }
};
</script>

<style scoped>
.home {
    position: relative;
    height: 100vh;
    width: 100%;
    text-align: center;
}
.expert {
    border: none;
    height: 99%;
    min-height: 520px;
    width: 520px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/pages/wz/expert.vue